import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.79785 14.8958C11.7179 14.8958 14.8958 11.718 14.8958 7.79791C14.8958 3.87785 11.7179 0.700012 7.79785 0.700012C3.87779 0.700012 0.699951 3.87785 0.699951 7.79791C0.699951 11.718 3.87779 14.8958 7.79785 14.8958Z",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.79785 3.53918V7.79792L10.637 9.2175",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgClock;
